<template>
  <v-row no-gutters class="tw:mt-6 tw:p-2.5 tw:bg-gray-50 tw:border tw:border-gray-100 tw:rounded-base">
    <v-col class="tw:text-left tw:flexcol-3.5">
      <div class="tw:font-medium tw:text-sm tw:flexrow-2 tw:items-center">
        <span>{{ $i18n.t('sidebar.temporaryLayers.title') }}</span>
        <v-tooltip bottom color="font">
          <template #activator="{ on }">
            <v-icon size="18" v-on="on" color="var(--tw-color-gray-500)">mdi-help-circle</v-icon>
          </template>
          {{ $i18n.t('sidebar.temporaryLayers.info') }}
        </v-tooltip>
      </div>
      <div>
        <temporary-layers-list-item
          v-for="layer in layers"
          :key="layer.id"
          :metadata="layer"
          @openSaveAsLayerDialog="openSaveAsLayerDialog"
        />
      </div>
    </v-col>
    <save-geojson-as-layer-dialog
      v-if="isSaveAsLayerDialogVisible"
      :is-visible.sync="isSaveAsLayerDialogVisible"
      :title="$i18n.t('sidebar.temporaryLayers.saveAsLayerTitle')"
      :body="$i18n.t('sidebar.temporaryLayers.saveAsLayerTitleBody')"
      v-bind="saveAsLayerDialogData"
      @close="closeSaveAsLayerDialog"
    />
  </v-row>
</template>

<script>
import TemporaryLayersListItem from '@/components/TemporaryLayersListItem';
import SaveGeojsonAsLayerDialog from '@/components/SaveGeojsonAsLayerDialog';

export default {
  name: 'TemporaryLayersList',
  components: {
    TemporaryLayersListItem,
    SaveGeojsonAsLayerDialog,
  },
  props: {
    layers: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    isSaveAsLayerDialogVisible: false,
    saveAsLayerDialogData: {},
  }),
  methods: {
    openSaveAsLayerDialog(name, geometry, styleWeb) {
      this.saveAsLayerDialogData = {
        name,
        geometry,
        styleWeb,
      };
      this.isSaveAsLayerDialogVisible = true;
    },
    closeSaveAsLayerDialog() {
      this.isSaveAsLayerDialogVisible = false;
      this.saveAsLayerDialogData = {};
    },
  },
};
</script>
